import { render } from "./CreateProvisioningTokenDialog.vue?vue&type=template&id=2a2669b6"
import script from "./CreateProvisioningTokenDialog.vue?vue&type=script&lang=js"
export * from "./CreateProvisioningTokenDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__